import React from "react";

export const Divider = ({ className = "" }) => (
  <div className={`flex items-center justify-center gap-3 ${className}`}>
    <span className="block h-px w-10 bg-terracotta" />
    <span className="uf-diamond" />
    <span className="block h-px w-10 bg-terracotta" />
  </div>
);
